import { localFiltersInitialState } from './local-filters.state';
import { LocalFiltersActionsUnion, LocalFiltersActionTypes } from './local-filters.actions';

export function localFiltersReducer(state = localFiltersInitialState, action: LocalFiltersActionsUnion) {
  switch (action.type) {
    case LocalFiltersActionTypes.SAVE_LOCAL_FILTERS:
      return {...state, saving: true};
    case LocalFiltersActionTypes.SAVE_LOCAL_FILTERS_SUCCESS:
      return {
        ...state,
        payload: action.payload.filtersToSave,
        saving: false,
        error: null
      };
    case LocalFiltersActionTypes.SAVE_LOCAL_FILTERS_FAILURE:
      return {
        ...state,
        payload: { ...localFiltersInitialState.payload },
        saving: false,
        error: action.payload.error
      };
    case LocalFiltersActionTypes.CLEAR_LOCAL_FILTERS:
      return {
        ...localFiltersInitialState
      };
    default:
      return state;
  }
}
